import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import appointmentService from '../../services/appointmentService';

export const fetchAppointments = createAsyncThunk('appointments/fetchAppointments', async (params, { rejectWithValue }) => {
  try {
    const response = await appointmentService.getAllAppointments(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch appointments');
  }
});

export const updateAppointmentStatus = createAsyncThunk('appointments/updateStatus', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await appointmentService.updateStatus(id, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update status');
  }
});

export const fetchStats = createAsyncThunk('appointments/fetchStats', async (_, { rejectWithValue }) => {
  try {
    const response = await appointmentService.getStats();
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch stats');
  }
});

const appointmentsSlice = createSlice({
  name: 'appointments',
  initialState: {
    appointments: [],
    stats: null,
    totalAppointments: 0,
    totalPages: 0,
    isLoading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointments = action.payload.data;
        state.totalAppointments = action.payload.pagination?.totalItems || 0;
        state.totalPages = action.payload.pagination?.totalPages || 0;
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateAppointmentStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAppointmentStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.appointments.findIndex((a) => a._id === action.payload.data._id);
        if (index !== -1) {
          state.appointments[index] = action.payload.data;
        }
        state.success = true;
      })
      .addCase(updateAppointmentStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.stats = action.payload.data;
      });
  },
});

export const { resetSuccess, clearError } = appointmentsSlice.actions;
export default appointmentsSlice.reducer;
